export {
  ClientMetadata,
  BrowserOAuthClient as OAuthClient,
  clientMetadataSchema,
} from "@atproto/oauth-client-browser";
